import React, { useContext } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import SubTitle from '@components/common/SubTitle';
import WhiteTextButton from '@components/common/WhiteTextButton';

import { AppConfigContext } from '@providers/AppConfigProvider';

export default function Request(): React.JSX.Element {
  const { pathRoot, isMobile } = useContext(AppConfigContext);
  return (
    <Box className="mt-[72px] max-md:mt-12 mx-24 max-md:mx-5">
      <Box>
        <SubTitle title="資料請求" />
      </Box>
      {isMobile ? (
        <Box className="flex flex-col">
          <Box className="text-sm leading-relaxed">
            リノベーションの基本や事例、買い方が丸っとわかる！オリジナル冊子を無料でお届けします。
          </Box>
          <Box className="mt-6">
            <Link href="https://renovefudosan.com/request/" target="_blank" rel="noopener noreferrer">
              <img
                src={`${pathRoot}/assets/images/common/catalog_sp.jpg`}
                alt="sellLabel"
                style={{ cursor: 'pointer' }}
                className="w-full object-contain"
                width="95"
                height="62"
              />
            </Link>
          </Box>
        </Box>
      ) : (
        <Box className="relative flex gap-x-2">
          <Box className="flex flex-col justify-between w-[41%] max-w-[264px]">
            <Box className="md:mb-[90px] text-base text-sm leading-7 max-md:leading-6">
              リノベーションの基本や事例、
              <br />
              買い方が丸っとわかる！
              <br />
              オリジナル冊子を無料でお届けします。
            </Box>
            <Box className="flex justify-between">
              <WhiteTextButton href="https://renovefudosan.com/request/" label="資料請求" handleClick={() => {}} />
            </Box>
          </Box>
          <Box className="absolute top-[-52px] right-0 w-[59%]">
            <Link
              href="https://renovefudosan.com/request/"
              target="_blank"
              rel="noopener noreferrer"
              className="rf-hover-element flex justify-end"
            >
              <img
                src={`${pathRoot}/assets/images/common/catalog_pc.jpg`}
                alt="sellLabel"
                style={{ cursor: 'pointer' }}
                className="max-w-[620px] max-h-[282px] w-full object-contain"
                width="124"
                height="56"
              />
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
}
